module.exports = __webpack_public_path__ + "img/bagage.9710b3e2.svg";